import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ClientRoutes from "../../navigation/Routes";
import { login, registerDIY } from "../../store/reducers/authReducer";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import FilterBar from "../common/others/FilterBar";
import { getImageUrl2 } from "../common/others/Functions";

const C = {
  plumDark: "#1e5a8e",
  plumLight: "#5ba3d4",
  blueDark: "#1e5a8e",
  blueLight: "#5ba3d4",
  goldDark: "#1e5a8e",
  goldLight: "#5ba3d4",
  bg: "#F8F9FA",
  bgCard: "#FFFFFF",
  text: "#2D2D2D",
  textSoft: "#5E5E5E",
  border: "#E8E8EC",
};

const WHATSAPP_AGOROT_PER_MSG = 25;
const SMS_AGOROT_PER_MSG = 8;
const PACKAGE_MIN = 10;
const PACKAGE_MAX = 500;
const PACKAGE_STEP = 10;

const MEDIA_ITEMS = [
  {
    type: "image",
    src: "/media/diy-screenshot1.png",
    alt: "מערכת סידורי הושבה",
    title: "סידורי הושבה",
  },
  {
    type: "image",
    src: "/media/diy-screenshot2.png",
    alt: "ניהול אורחים",
    title: "ניהול אורחים",
  },
  {
    type: "image",
    src: "/media/carousel-thanks.png",
    alt: "הודעת תודה",
    title: "הודעת תודה",
  },
  {
    type: "image",
    src: "/media/carousel-invitation.png",
    alt: "ווצאפ ראשון",
    title: "ווצאפ ראשון",
  },
  {
    type: "image",
    src: "/media/carousel-rsvp-status.png",
    alt: "ווצאפ שני",
    title: "ווצאפ שני",
  },
  {
    type: "image",
    src: "/media/carousel-reminder-link.png",
    alt: "סמס שני",
    title: "סמס שני",
  },
  {
    type: "image",
    src: "/media/carousel-invitation-link.png",
    alt: "סמס ראשון",
    title: "סמס ראשון",
  },
  {
    type: "image",
    src: "/media/carousel-today-event.png",
    alt: "תזכורת ווצאפ",
    title: "תזכורת ווצאפ",
  },
  {
    type: "image",
    src: "/media/carousel-event-details.png",
    alt: "תזכורת סמס",
    title: "תזכורת סמס",
  },
  {
    type: "video",
    src: `${getImageUrl2()}videos/v1.mov`,
    // src: "/media/diy-video1.mov",
    title: "דוגמא להזמנה דיגיטלית",
  },
  {
    type: "video",
    src: `${getImageUrl2()}videos/v2.mov`,
    // src: "/media/diy-video3.mov",
    title: "דוגמא להזמנה דיגיטלית",
  },
  {
    type: "video",
    src: `${getImageUrl2()}videos/v3.mov`,
    // src: "/media/diy-video4.mov",
    title: "דוגמא להזמנה דיגיטלית",
  },
  {
    type: "video",
    src: `${getImageUrl2()}videos/v4.mov`,
    // src: "/media/diy-video5.mov",
    title: "דוגמא להזמנה דיגיטלית",
  },
];

const DEFAULT_UNAUTH_STORAGE_KEY = "defaultUnAuthRoute";

const MainUnAuthDIY = ({ onRegisterSubmit, onLoginSubmit }) => {
  const history = useHistory();
  const [whatsappQty, setWhatsappQty] = useState(100);

  useEffect(() => {
    localStorage.setItem(DEFAULT_UNAUTH_STORAGE_KEY, "mainDIY");
  }, []);
  const [smsQty, setSmsQty] = useState(100);
  const [registerPopupOpen, setRegisterPopupOpen] = useState(false);
  const [registerPhone, setRegisterPhone] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [registerEventDate, setRegisterEventDate] = useState("");
  const [registerEventType, setRegisterEventType] = useState("חתונה");
  const [registerError, setRegisterError] = useState("");

  const EVENT_TYPE_OPTIONS = [{ name: "חתונה" }, { name: "אחר" }];
  const [loginPopupOpen, setLoginPopupOpen] = useState(false);
  const [loginPhone, setLoginPhone] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [mediaCarouselIndex, setMediaCarouselIndex] = useState(0);
  const [welcomePopupOpen, setWelcomePopupOpen] = useState(false);
  const [welcomePhone, setWelcomePhone] = useState("");
  const [welcomePassword, setWelcomePassword] = useState("");
  const dispatch = useDispatch();

  const goTo = (path) => {
    history.push(path);
  };

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    setRegisterError("");
    const passwordTrimmed = registerPassword.trim();
    if (!/^\d{6}$/.test(passwordTrimmed)) {
      setRegisterError("הסיסמה חייבת להכיל בדיוק 6 ספרות");
      return;
    }
    if (!registerPhone.trim()) {
      setRegisterError("נא להזין מספר פלאפון");
      return;
    }
    if (!registerEventDate) {
      setRegisterError("נא לבחור תאריך אירוע");
      return;
    }

    const data = {
      phone: registerPhone.trim(),
      password: passwordTrimmed,
      date: registerEventDate,
      eventType: registerEventType == "חתונה" ? true : false,
    };

    dispatch(registerDIY(data)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        setWelcomePhone(data.phone);
        setWelcomePassword(data.password);
        setWelcomePopupOpen(true);
      } else toast.error(res.payload?.error);
    });
    if (typeof onRegisterSubmit === "function") {
      onRegisterSubmit(data);
    }
    setRegisterPopupOpen(false);
    setRegisterPhone("");
    setRegisterPassword("");
    setRegisterEventDate("");
    setRegisterEventType("חתונה");
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    setLoginError("");
    const passwordTrimmed = loginPassword.trim();
    if (!/^\d{6}$/.test(passwordTrimmed)) {
      setLoginError("הסיסמה חייבת להכיל בדיוק 6 ספרות");
      return;
    }
    if (!loginPhone.trim()) {
      setLoginError("נא להזין מספר פלאפון");
      return;
    }
    const data = {
      phone: loginPhone.trim(),
      password: passwordTrimmed,
    };
    dispatch(login(data)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
    if (typeof onLoginSubmit === "function") {
      onLoginSubmit(data);
    }
    setLoginPopupOpen(false);
    setLoginPhone("");
    setLoginPassword("");
  };

  const whatsappTotalAgorot = whatsappQty * WHATSAPP_AGOROT_PER_MSG;
  const smsTotalAgorot = smsQty * SMS_AGOROT_PER_MSG;
  const formatPrice = (agorot) => {
    const shekels = (agorot / 100).toFixed(2);
    return `₪${shekels}`;
  };

  return (
    <div style={page}>
      {/* סרגל עליון — הרשמה בימין, התחברות בשמאל */}
      <div style={topBar}>
        <button
          type="button"
          style={topBarRegisterBtn}
          onClick={() => setRegisterPopupOpen(true)}
        >
          הרשמה
        </button>
        <button
          type="button"
          style={topBarLoginBtn}
          onClick={() => setLoginPopupOpen(true)}
        >
          התחברות
        </button>
      </div>
      {/* Hero — רקע לבן, מסר מכירתי */}
      <section style={heroSection}>
        <h1 style={heroTitle}>
          <span style={heroBrand}>Do It Yourself</span>
        </h1>
        <p style={heroDesc}>מערכת אישורי הגעה הזולה והפשוטה בארץ!</p>
      </section>

      {/* Steps — עיצוב בהשראת הרפרנס */}
      <section style={section}>
        <style>{stepsGridStyle}</style>
        <h2 style={sectionTitle}>איך זה עובד?</h2>
        <div style={stepsGrid} className="steps-grid-diy">
          <div style={stepCard}>
            <div style={stepCardHeader}>
              <span style={stepCardNum}>01</span>
              <div style={stepIconWrap}>
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={stepIconSvg}
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </div>
            </div>
            <h3 style={stepCardTitle}>יוצרים אירוע</h3>
            <p style={stepCardDesc}>
              הזנת פרטי האירוע כגון אולם, תאריך, שמות ועוד...
            </p>
          </div>

          <div style={stepCard}>
            <div style={stepCardHeader}>
              <span style={stepCardNum}>02</span>
              <div style={stepIconWrap}>
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={stepIconSvg}
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
            </div>
            <h3 style={stepCardTitle}>מוסיפים אורחים</h3>
            <p style={stepCardDesc}>כל האפשרויות להוספה:</p>
            <ul style={stepCardList}>
              <li style={stepCardListItem}>
                <span style={stepCheck}>✓</span>
                <span style={stepCardListText}>ייבוא מאקסל</span>
              </li>
              <li style={stepCardListItem}>
                <span style={stepCheck}>✓</span>
                <span style={stepCardListText}>ייבוא אנשי קשר מהנייד</span>
              </li>
              <li style={stepCardListItem}>
                <span style={stepCheck}>✓</span>
                <span style={stepCardListText}>הקלדה ידנית</span>
              </li>
            </ul>
          </div>

          <div style={stepCard}>
            <div style={stepCardHeader}>
              <span style={stepCardNum}>03</span>
              <div style={stepIconWrap}>
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={stepIconSvg}
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
            </div>
            <h3 style={stepCardTitle}>מעלים הזמנה</h3>
            <p style={stepCardDesc}>
              העלו את הזמנת האירוע אשר תישלח לכל האורחים יחד עם אישור ההגעה.
            </p>
            מגוון אפשרויות נוספות בהזמנה הדיגיטלית כגון ניהול הסעות, בחירת מנות
            (טבעוני, צמחוני, גלאט ועוד...), מקום להשארת ברכה וכל הודעה שתרצו
            להדגיש לאורחים
          </div>

          <div style={stepCard}>
            <div style={stepCardHeader}>
              <span style={stepCardNum}>04</span>
              <div style={stepIconWrap}>
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={stepIconSvg}
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
            </div>
            <h3 style={stepCardTitle}>שולחים אישורי הגעה</h3>
            <p style={stepCardDesc}>
              בחרו תבנית, רכשו חבילת SMS או WhatsApp והפיצו לאורחים — במחירים
              הזולים בארץ.
            </p>
            אנו משתמשים בתבניות הודעה שעובדות בשטח כבר שנים, עם נתונים מוכחים של
            אחוזי תגובה גבוהים. ההודעות מנוסחות בצורה אישית ומזמינה, וניתן
            להגדיר פתיח שונה לכל קטגוריית אורחים לקבלת מענה מקסימלי.{" "}
          </div>
        </div>

        <div style={ctaStartCard}>
          <h3 style={ctaStartTitle}>פשוט, נכון?</h3>
          <p style={ctaStartDesc}>
            התחילו עכשיו ותראו כמה קל
            <br />
            לנהל אירוע
          </p>
          <button
            type="button"
            style={ctaStartBtn}
            onClick={() => setRegisterPopupOpen(true)}
          >
            <span style={ctaStartBtnArrow}>←</span>
            צור אירוע עכשיו
          </button>
        </div>
      </section>

      {/* פופאפ הרשמה */}
      {registerPopupOpen && (
        <>
          <div
            style={registerPopupBackdrop}
            onClick={() => setRegisterPopupOpen(false)}
            aria-hidden="true"
          />
          <div
            style={registerPopupBox}
            role="dialog"
            aria-labelledby="register-popup-title"
          >
            <h2 id="register-popup-title" style={registerPopupTitle}>
              הרשמה
            </h2>
            <form onSubmit={handleRegisterSubmit} style={registerForm}>
              <div style={registerFormRow}>
                <label style={registerLabel}>
                  טלפון
                  <input
                    type="tel"
                    value={registerPhone}
                    onChange={(e) =>
                      setRegisterPhone(
                        e.target.value.replace(/\D/g, "").slice(0, 10),
                      )
                    }
                    placeholder="05XXXXXXXX"
                    style={registerInput}
                    autoComplete="tel"
                    inputMode="numeric"
                  />
                </label>
                <label style={registerLabel}>
                  סיסמה (6 ספרות)
                  <input
                    type="password"
                    value={registerPassword}
                    onChange={(e) =>
                      setRegisterPassword(
                        e.target.value.replace(/\D/g, "").slice(0, 6),
                      )
                    }
                    placeholder="XXXXXX"
                    style={registerInput}
                    maxLength={6}
                    inputMode="numeric"
                    autoComplete="new-password"
                  />
                </label>
              </div>
              <div style={registerFormRow}>
                <label style={registerLabel}>
                  סוג האירוע
                  <div style={registerFilterBarWrap}>
                    <FilterBar
                      data={EVENT_TYPE_OPTIONS}
                      property={registerEventType}
                      setProperty={setRegisterEventType}
                      color={C.blueDark}
                      padding="7px 14px"
                    />
                  </div>
                </label>
                <label style={registerLabel}>
                  תאריך
                  <input
                    type="date"
                    value={registerEventDate}
                    onChange={(e) => setRegisterEventDate(e.target.value)}
                    style={registerInput}
                  />
                </label>
              </div>
              {registerError && (
                <p style={registerErrorText}>{registerError}</p>
              )}
              <div style={registerPopupActions}>
                <button type="submit" style={registerSubmitBtn}>
                  שליחה
                </button>
                <button
                  type="button"
                  style={registerCancelBtn}
                  onClick={() => setRegisterPopupOpen(false)}
                >
                  ביטול
                </button>
              </div>
            </form>
          </div>
        </>
      )}

      {/* פופאפ חגיגי אחרי הרשמה מוצלחת */}
      {welcomePopupOpen && (
        <>
          <div
            style={registerPopupBackdrop}
            onClick={() => setWelcomePopupOpen(false)}
            aria-hidden="true"
          />
          <div
            style={welcomePopupBox}
            role="dialog"
            aria-labelledby="welcome-popup-title"
          >
            <h2 id="welcome-popup-title" style={welcomePopupTitle}>
              ברוכים הבאים!
            </h2>
            <p style={welcomePopupIntro}>פרטי התחברות למערכת:</p>
            <div style={welcomePopupDetails}>
              <p style={welcomePopupRow}>
                <strong>לינק:</strong>{" "}
                <a
                  href="https://callup.ltd/ua/mainDIY"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={welcomePopupLink}
                >
                  https://callup.ltd/ua/mainDIY
                </a>
              </p>
              <p style={welcomePopupRow}>
                <strong>טלפון:</strong> {welcomePhone}
              </p>
              <p style={welcomePopupRow}>
                <strong>סיסמא:</strong> {welcomePassword}
              </p>
            </div>
            <p style={welcomePopupNote}>
              ניתן להתחבר ממספר מכשירים במקביל עם אותם פרטי התחברות
            </p>
            <p style={welcomePopupCheers}>בהצלחה 🙂</p>
            <button
              type="button"
              style={registerSubmitBtn}
              onClick={() => setWelcomePopupOpen(false)}
            >
              סגור
            </button>
          </div>
        </>
      )}

      {/* חבילות */}
      <section style={packagesSection} className="packages-section-diy">
        <style>{`
          .packages-section-diy input[type="range"] {
            -webkit-appearance: none;
            appearance: none;
            background: transparent;
            direction: rtl;
          }
          /* במערכת הקואורדינטות של ה-track: 0% = שמאל, 100% = ימין. צבע מ-range-pct ל-100% = מימין לפקד */
          .packages-section-diy .package-range-wa input::-webkit-slider-runnable-track {
            height: 8px;
            background: linear-gradient(to left, #8FA87A 0%, #8FA87A var(--range-pct), #e8e8ec var(--range-pct), #e8e8ec 100%);
            border-radius: 4px;
          }
          .packages-section-diy .package-range-wa input::-moz-range-track {
            height: 8px;
            background: linear-gradient(to left, #8FA87A 0%, #8FA87A var(--range-pct), #e8e8ec var(--range-pct), #e8e8ec 100%);
            border-radius: 4px;
          }
          .packages-section-diy .package-range-sms input::-webkit-slider-runnable-track {
            height: 8px;
            background: linear-gradient(to left, #D4C88A 0%, #D4C88A var(--range-pct), #e8e8ec var(--range-pct), #e8e8ec 100%);
            border-radius: 4px;
          }
          .packages-section-diy .package-range-sms input::-moz-range-track {
            height: 8px;
            background: linear-gradient(to left, #D4C88A 0%, #D4C88A var(--range-pct), #e8e8ec var(--range-pct), #e8e8ec 100%);
            border-radius: 4px;
          }
          .packages-section-diy .package-range-wa input::-webkit-slider-thumb {
            -webkit-appearance: none;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #6B8E5C;
            cursor: pointer;
            margin-top: -5px;
          }
          .packages-section-diy .package-range-wa input::-moz-range-thumb {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #6B8E5C;
            cursor: pointer;
            border: none;
          }
          .packages-section-diy .package-range-sms input::-webkit-slider-thumb {
            -webkit-appearance: none;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #B8A86A;
            cursor: pointer;
            margin-top: -5px;
          }
          .packages-section-diy .package-range-sms input::-moz-range-thumb {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #B8A86A;
            cursor: pointer;
            border: none;
          }
          .packages-grid-diy {
            grid-template-columns: 1fr;
          }
          @media (min-width: 720px) {
            .packages-grid-diy {
              grid-template-columns: repeat(2, 1fr);
            }
          }
        `}</style>
        <h2 style={packagesTitle}>עלויות</h2>
        <div style={packagesGrid} className="packages-grid-diy">
          <div style={{ ...packageCard, ...packageCardWhatsApp }}>
            <div style={packageCardHeader}>
              <span style={packageCardLabel}>WhatsApp</span>
              <span style={packageCardPrice}>
                {formatPrice(WHATSAPP_AGOROT_PER_MSG)} להודעה
              </span>
            </div>
            <div style={packageControlWrap}>
              <div
                style={{
                  ...packageRangeWrap,
                  ["--range-pct"]: `${((whatsappQty - PACKAGE_MIN) / (PACKAGE_MAX - PACKAGE_MIN)) * 100}%`,
                }}
                className="package-range-wa"
              >
                <input
                  type="range"
                  min={PACKAGE_MIN}
                  max={PACKAGE_MAX}
                  step={PACKAGE_STEP}
                  value={whatsappQty}
                  onChange={(e) => setWhatsappQty(Number(e.target.value))}
                  style={packageRange}
                />
              </div>
              <div style={packageSummary}>
                <span style={packageQty}>{whatsappQty} הודעות</span>
                <span style={packageTotal}>
                  {formatPrice(whatsappTotalAgorot)}
                </span>
              </div>
            </div>
          </div>
          <div style={{ ...packageCard, ...packageCardSms }}>
            <div style={packageCardHeader}>
              <span style={packageCardLabel}>SMS</span>
              <span style={packageCardPrice}>
                {formatPrice(SMS_AGOROT_PER_MSG)} להודעה
              </span>
            </div>
            <div style={packageControlWrap}>
              <div
                style={{
                  ...packageRangeWrap,
                  ["--range-pct"]: `${((smsQty - PACKAGE_MIN) / (PACKAGE_MAX - PACKAGE_MIN)) * 100}%`,
                }}
                className="package-range-sms"
              >
                <input
                  type="range"
                  min={PACKAGE_MIN}
                  max={PACKAGE_MAX}
                  step={PACKAGE_STEP}
                  value={smsQty}
                  onChange={(e) => setSmsQty(Number(e.target.value))}
                  style={packageRange}
                />
              </div>
              <div style={packageSummary}>
                <span style={packageQty}>{smsQty} הודעות</span>
                <span style={packageTotal}>{formatPrice(smsTotalAgorot)}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* תמונות וסרטונים מהמערכת — קרוסלה */}
      <section style={mediaSection}>
        <h2 style={mediaSectionTitle}>תמונות וסרטונים מהמערכת</h2>
        <div style={carouselWrap}>
          <button
            type="button"
            style={{ ...carouselBtn, left: 0, right: "auto" }}
            onClick={() =>
              setMediaCarouselIndex((i) =>
                i === 0 ? MEDIA_ITEMS.length - 1 : i - 1,
              )
            }
            aria-label="פריט קודם"
          >
            ›
          </button>
          <div style={carouselSlide}>
            {MEDIA_ITEMS.map((item, index) => (
              <div
                key={index}
                style={{
                  ...carouselSlideInner,
                  display: index === mediaCarouselIndex ? "block" : "none",
                }}
              >
                <div style={mediaCard}>
                  {item.type === "image" ? (
                    <img
                      src={item.src}
                      alt={item.alt || ""}
                      style={mediaImage}
                    />
                  ) : (
                    <video
                      src={item.src}
                      controls
                      style={mediaVideo}
                      playsInline
                      preload="metadata"
                    />
                  )}
                  {item.title && <p style={mediaCardTitle}>{item.title}</p>}
                </div>
              </div>
            ))}
          </div>
          <button
            type="button"
            style={{ ...carouselBtn, left: "auto", right: 0 }}
            onClick={() =>
              setMediaCarouselIndex((i) =>
                i === MEDIA_ITEMS.length - 1 ? 0 : i + 1,
              )
            }
            aria-label="פריט הבא"
          >
            ‹
          </button>
        </div>
        <div style={carouselDots}>
          {MEDIA_ITEMS.map((_, index) => (
            <button
              key={index}
              type="button"
              style={{
                ...carouselDot,
                ...(index === mediaCarouselIndex ? carouselDotActive : {}),
              }}
              onClick={() => setMediaCarouselIndex(index)}
              aria-label={`פריט ${index + 1}`}
              aria-current={index === mediaCarouselIndex ? "true" : undefined}
            />
          ))}
        </div>
      </section>

      {/* Footer — מוכנים להתחיל + שירותים נוספים + התחברות */}
      <section style={ctaSection}>
        {/* <div style={footerExtra}> */}
        <span style={footerExtraLabel}>שירותים נוספים</span>
        <p style={footerExtraText}>סידורי הושבה פרונטליים</p>
        <p style={footerExtraText}>מתנות באשראי</p>
        <a
          href="https://wa.me/972547439322"
          target="_blank"
          rel="noopener noreferrer"
          style={footerWhatsAppLink}
        >
          לחצו כאן לפניה בוואטסאפ לפרטים נוספים
        </a>
        {/* </div> */}
        <button
          type="button"
          style={footerLoginBtn}
          onClick={() => setLoginPopupOpen(true)}
        >
          כבר רשומים? — לחצו להתחברות!
        </button>
      </section>

      {/* פופאפ התחברות */}
      {loginPopupOpen && (
        <>
          <div
            style={registerPopupBackdrop}
            onClick={() => setLoginPopupOpen(false)}
            aria-hidden="true"
          />
          <div
            style={registerPopupBox}
            role="dialog"
            aria-labelledby="login-popup-title"
          >
            <h2 id="login-popup-title" style={registerPopupTitle}>
              התחברות
            </h2>
            <form onSubmit={handleLoginSubmit} style={registerForm}>
              <div style={registerFormRow}>
                <label style={registerLabel}>
                  טלפון
                  <input
                    type="tel"
                    value={loginPhone}
                    onChange={(e) =>
                      setLoginPhone(
                        e.target.value.replace(/\D/g, "").slice(0, 10),
                      )
                    }
                    placeholder="05XXXXXXXX"
                    style={registerInput}
                    autoComplete="tel"
                    inputMode="numeric"
                  />
                </label>
                <label style={registerLabel}>
                  סיסמה (6 ספרות)
                  <input
                    type="password"
                    value={loginPassword}
                    onChange={(e) =>
                      setLoginPassword(
                        e.target.value.replace(/\D/g, "").slice(0, 6),
                      )
                    }
                    placeholder="XXXXXX"
                    style={registerInput}
                    maxLength={6}
                    inputMode="numeric"
                    autoComplete="current-password"
                  />
                </label>
              </div>
              {loginError && <p style={registerErrorText}>{loginError}</p>}
              <div style={registerPopupActions}>
                <button type="submit" style={registerSubmitBtn}>
                  כניסה
                </button>
                <button
                  type="button"
                  style={registerCancelBtn}
                  onClick={() => setLoginPopupOpen(false)}
                >
                  ביטול
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
};

const page = {
  width: "100%",
  minHeight: "100vh",
  boxSizing: "border-box",
  background: C.bg,
  color: C.text,
  fontFamily: "'Heebo', sans-serif",
  direction: "rtl",
  padding: 0,
};

const topBar = {
  position: "sticky",
  top: 0,
  left: 0,
  right: 0,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 24px",
  background: C.bgCard,
  boxShadow: "0 1px 0 rgba(0,0,0,0.06)",
  zIndex: 100,
};

const topBarRegisterBtn = {
  padding: "8px 18px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#fff",
  background: `linear-gradient(135deg, ${C.blueDark}, ${C.blueLight})`,
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
};

const topBarLoginBtn = {
  padding: "8px 18px",
  fontSize: "14px",
  fontWeight: "600",
  color: C.blueDark,
  background: "transparent",
  border: `1px solid ${C.blueDark}`,
  borderRadius: "8px",
  cursor: "pointer",
};

const header = {
  background: `linear-gradient(145deg, ${C.blueDark}, ${C.blueLight})`,
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  padding: "16px 24px",
};

const headerInner = {
  maxWidth: 960,
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 12,
};

const heroSection = {
  width: "100%",
  background: C.bgCard,
  padding: "48px 24px 56px",
  textAlign: "center",
  boxShadow: "0 1px 0 rgba(0,0,0,0.06)",
};

const heroTitle = {
  margin: 0,
  fontSize: "clamp(44px, 9vw, 64px)",
  fontWeight: "700",
  color: C.text,
  lineHeight: 1.35,
  maxWidth: 720,
  marginLeft: "auto",
  marginRight: "auto",
};

const heroBrand = {
  color: C.goldDark,
  letterSpacing: "0.02em",
};

const heroDesc = {
  margin: "8px 0 0",
  fontSize: "clamp(17px, 3vw, 22px)",
  fontWeight: "600",
  color: C.text,
  lineHeight: 1.4,
};

const heroSub = {
  margin: 0,
  fontSize: "17px",
  color: C.textSoft,
  maxWidth: 480,
  marginLeft: "auto",
  marginRight: "auto",
  lineHeight: 1.5,
};

const section = {
  padding: "32px 24px 48px",
  maxWidth: 960,
  margin: "0 auto",
  boxSizing: "border-box",
};

const sectionTitle = {
  margin: "0 0 25px",
  fontSize: "24px",
  fontWeight: "700",
  color: C.text,
  textAlign: "center",
};

const sectionSub = {
  margin: "0 0 32px",
  fontSize: "15px",
  color: C.textSoft,
  textAlign: "center",
};

const packagesSection = {
  padding: "0px 24px 56px",
  background: `linear-gradient(180deg, ${C.bg} 0%, rgba(30, 90, 142, 0.06) 100%)`,
  direction: "rtl",
};

const packagesTitle = {
  margin: "0 0 28px",
  fontSize: "26px",
  fontWeight: "700",
  color: C.text,
  textAlign: "center",
};

const mediaSection = {
  padding: "48px 24px 56px",
  maxWidth: 960,
  margin: "0 auto",
  direction: "rtl",
};

const mediaSectionTitle = {
  margin: "0 0 28px",
  fontSize: "26px",
  fontWeight: "700",
  color: C.text,
  textAlign: "center",
};

const mediaGrid = {
  display: "grid",
  gap: "24px",
};

const mediaCard = {
  background: C.bgCard,
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  border: `1px solid ${C.border}`,
};

const mediaImage = {
  width: "100%",
  height: "auto",
  display: "block",
  verticalAlign: "top",
};

const mediaVideo = {
  width: "100%",
  height: "auto",
  display: "block",
  background: "#000",
};

const mediaCardTitle = {
  margin: 0,
  padding: "12px 16px",
  fontSize: "15px",
  fontWeight: "600",
  color: C.text,
  textAlign: "center",
};

const carouselWrap = {
  position: "relative",
  maxWidth: 520,
  margin: "0 auto 20px",
};

const carouselBtn = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  width: 44,
  height: 44,
  borderRadius: "50%",
  border: `2px solid ${C.border}`,
  background: C.bgCard,
  fontSize: "28px",
  lineHeight: 1,
  cursor: "pointer",
  color: C.text,
  zIndex: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

const carouselSlide = {
  width: "100%",
  overflow: "hidden",
  padding: "0 52px",
};

const carouselSlideInner = {
  width: "100%",
};

const carouselDots = {
  display: "flex",
  justifyContent: "center",
  gap: 8,
  flexWrap: "wrap",
  padding: "0 24px",
};

const carouselDot = {
  width: 10,
  height: 10,
  borderRadius: "50%",
  border: "none",
  background: C.border,
  cursor: "pointer",
  padding: 0,
  transition: "background 0.2s",
};

const carouselDotActive = {
  background: C.plumDark,
};

const packagesGrid = {
  maxWidth: 720,
  margin: "0 auto",
  display: "grid",
  gap: "24px",
};

const packageCard = {
  position: "relative",
  borderRadius: "16px",
  padding: "24px",
  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  background: C.bgCard,
};

const packageCardWhatsApp = {
  color: C.text,
  border: `2px solid #8FA87A`,
  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
};

const packageCardSms = {
  color: C.text,
  border: `2px solid #B8A86A`,
  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
};

const packageCardHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "8px",
  marginBottom: "20px",
};

const packageCardLabel = {
  fontSize: "20px",
  fontWeight: "700",
};

const packageCardPrice = {
  fontSize: "15px",
  opacity: 0.95,
};

const packageControlWrap = {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

const packageRangeWrap = {
  background: "#fff",
  border: `1px solid ${C.border}`,
  borderRadius: "10px",
  padding: "12px 14px",
};

const packageRange = {
  width: "100%",
  height: "8px",
  cursor: "pointer",
  display: "block",
};

const packageSummary = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "17px",
  fontWeight: "600",
};

const packageQty = {
  opacity: 0.95,
};

const packageTotal = {
  fontSize: "20px",
};

const stepsGrid = {
  display: "grid",
  gap: "32px",
};

const stepsGridStyle = `
  .steps-grid-diy {
    grid-template-columns: 1fr;
  }
  @media (min-width: 720px) {
    .steps-grid-diy {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;

const stepCard = {
  background: C.bgCard,
  borderRadius: "16px",
  padding: "28px 24px",
  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  border: `1px solid ${C.border}`,
  position: "relative",
  textAlign: "right",
};

const stepCardHeader = {
  display: "flex",
  flexDirection: "row-reverse",
  alignItems: "flex-start",
  justifyContent: "flex-end",
  gap: "12px",
  marginBottom: "16px",
};

const stepCardNum = {
  fontSize: "48px",
  fontWeight: "700",
  color: C.border,
  lineHeight: 1,
  opacity: 0.7,
};

const stepIconWrap = {
  width: "45px",
  height: "45px",
  borderRadius: "10px",
  background: "linear-gradient(135deg, #1e5a8e 0%, #5ba3d4 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const stepIconSvg = {
  display: "block",
  width: 26,
  height: 26,
};

const stepCardTitle = {
  margin: "0 0 8px",
  fontSize: "22px",
  fontWeight: "700",
  color: C.text,
  lineHeight: 1.3,
};

const stepCardDesc = {
  margin: "0 0 16px",
  fontSize: "15px",
  color: C.textSoft,
  lineHeight: 1.6,
};

const stepCardList = {
  listStyle: "none",
  margin: 0,
  padding: 0,
  direction: "rtl",
};

const stepCardListItem = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  marginBottom: "8px",
  fontSize: "14px",
  color: C.textSoft,
  lineHeight: 1.5,
  flexDirection: "row",
  direction: "rtl",
  textAlign: "right",
};

const stepCardListText = {
  textAlign: "right",
  flex: 1,
};

const stepCheck = {
  width: "20px",
  height: "20px",
  minWidth: "20px",
  borderRadius: "50%",
  background: `linear-gradient(135deg, ${C.blueDark} 0%, ${C.blueLight} 100%)`,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  color: "#fff",
  fontSize: "12px",
  fontWeight: "bold",
};

const extraCard = {
  background: C.bgCard,
  borderRadius: "16px",
  padding: "20px 24px",
  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  border: `1px solid ${C.border}`,
  maxWidth: 560,
  margin: "0 auto",
};

const extraLabel = {
  fontSize: "13px",
  fontWeight: "600",
  color: C.goldDark,
  display: "block",
  marginBottom: "6px",
};

const extraText = {
  margin: 0,
  fontSize: "14px",
  color: C.textSoft,
  lineHeight: 1.5,
};

const extraWhatsAppLink = {
  display: "inline-block",
  marginTop: "14px",
  padding: "12px 20px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#fff",
  backgroundColor: "#25D366",
  textDecoration: "none",
  lineHeight: 1.5,
  borderRadius: "12px",
  cursor: "pointer",
  boxShadow: "0 2px 8px rgba(37, 211, 102, 0.35)",
  border: "none",
};

const ctaStartCard = {
  marginTop: "40px",
  padding: "40px 24px 36px",
  textAlign: "center",
  background: "linear-gradient(135deg, #1e5a8e 0%, #5ba3d4 100%)",
  borderRadius: "20px",
  boxShadow: "0 8px 32px rgba(30, 90, 142, 0.25)",
};

const ctaStartTitle = {
  margin: "0 0 12px",
  fontSize: "clamp(26px, 4.5vw, 34px)",
  fontWeight: "700",
  color: "#fff",
  lineHeight: 1.2,
};

const ctaStartDesc = {
  margin: "0 0 28px",
  fontSize: "17px",
  color: "rgba(255,255,255,0.95)",
  lineHeight: 1.5,
};

const ctaStartBtn = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  padding: "16px 32px",
  fontSize: "clamp(16px, 2.5vw, 18px)",
  fontWeight: "700",
  color: C.plumDark,
  background: "#fff",
  border: `2px solid rgba(30, 90, 142, 0.35)`,
  borderRadius: "14px",
  cursor: "pointer",
  boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
};

const ctaStartBtnArrow = {
  fontSize: "1.1em",
};

const registerPopupBackdrop = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.45)",
  zIndex: 1100,
};

const registerPopupBox = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "340px",
  background: C.bgCard,
  borderRadius: "14px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.04)",
  padding: "18px",
  zIndex: 1101,
  direction: "rtl",
};

const registerPopupTitle = {
  margin: "0 0 20px",
  fontSize: "17px",
  fontWeight: "700",
  color: C.text,
  textAlign: "center",
};

const registerForm = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const registerFormRow = {
  display: "flex",
  gap: "10px",
  alignItems: "flex-start",
};

const registerLabel = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flex: "1",
  minWidth: 0,
  fontSize: "12px",
  fontWeight: "600",
  color: C.textSoft,
};

const registerInput = {
  padding: "8px 10px",
  fontSize: "14px",
  border: `1px solid ${C.border}`,
  borderRadius: "8px",
  outline: "none",
};

const registerFilterBarWrap = {
  marginTop: "0px",
  alignSelf: "stretch",
  display: "flex",
  alignItems: "center",
};

const registerErrorText = {
  margin: 0,
  fontSize: "12px",
  color: "#c0392b",
};

const registerPopupActions = {
  display: "flex",
  gap: "8px",
  marginTop: "6px",
  justifyContent: "flex-end",
};

const registerSubmitBtn = {
  padding: "8px 18px",
  fontSize: "13px",
  fontWeight: "600",
  color: "#fff",
  background: `linear-gradient(135deg, ${C.blueDark}, ${C.blueLight})`,
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
};

const registerCancelBtn = {
  padding: "8px 18px",
  fontSize: "13px",
  color: C.textSoft,
  background: "none",
  border: `1px solid ${C.border}`,
  borderRadius: "8px",
  cursor: "pointer",
};

const welcomePopupBox = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "400px",
  background: C.bgCard,
  borderRadius: "16px",
  boxShadow: "0 12px 40px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.05)",
  padding: "24px 22px",
  zIndex: 1101,
  direction: "rtl",
  textAlign: "center",
};

const welcomePopupTitle = {
  margin: "0 0 16px",
  fontSize: "24px",
  fontWeight: "700",
  color: C.blueDark,
  lineHeight: 1.2,
};

const welcomePopupIntro = {
  margin: "0 0 12px",
  fontSize: "15px",
  fontWeight: "600",
  color: C.text,
};

const welcomePopupDetails = {
  margin: "0 0 14px",
  padding: "14px 16px",
  background: "rgba(30, 90, 142, 0.06)",
  borderRadius: "12px",
  textAlign: "right",
};

const welcomePopupRow = {
  margin: "0 0 8px",
  fontSize: "14px",
  color: C.text,
  lineHeight: 1.5,
};

const welcomePopupLink = {
  color: C.blueDark,
  fontWeight: "600",
  wordBreak: "break-all",
};

const welcomePopupNote = {
  margin: "0 0 12px",
  fontSize: "13px",
  color: C.textSoft,
  lineHeight: 1.5,
};

const welcomePopupCheers = {
  margin: "0 0 18px",
  fontSize: "16px",
  fontWeight: "600",
  color: C.text,
};

const ctaSection = {
  background: "linear-gradient(135deg, #1e5a8e 0%, #5ba3d4 100%)",
  padding: "56px 24px",
  textAlign: "center",
};

const ctaTitle = {
  margin: "0 0 10px",
  fontSize: "clamp(24px, 4vw, 32px)",
  fontWeight: "700",
  color: "#fff",
};

const ctaSub = {
  margin: 0,
  fontSize: "16px",
  color: "rgba(255,255,255,0.9)",
};

const footerExtra = {
  marginTop: "28px",
  paddingTop: "24px",
  borderTop: "1px solid rgba(255,255,255,0.25)",
  maxWidth: 400,
  marginLeft: "auto",
  marginRight: "auto",
  textAlign: "center",
};

const footerExtraLabel = {
  display: "block",
  fontSize: "14px",
  fontWeight: "600",
  color: "rgba(255,255,255,0.95)",
  marginBottom: "8px",
};

const footerExtraText = {
  margin: "4px 0",
  fontSize: "15px",
  color: "rgba(255,255,255,0.9)",
};

const footerWhatsAppLink = {
  display: "inline-block",
  marginTop: "12px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#fff",
  textDecoration: "underline",
};

const footerLoginBtn = {
  display: "block",
  margin: "24px auto 0",
  padding: "14px 28px",
  fontSize: "15px",
  fontWeight: "600",
  color: C.plumDark,
  background: "#fff",
  border: "1px solid rgba(255,255,255,0.5)",
  borderRadius: "12px",
  cursor: "pointer",
  boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
};

export default MainUnAuthDIY;
